(function() {
  const numberOfFlakes = 30; // pas aan: meer = zwaardere sneeuwval
  const container = document.createElement('div');
  container.id = 'snow-container';
  document.body.appendChild(container);

  for (let i = 0; i < numberOfFlakes; i++) {
    const flake = document.createElement('div');
    flake.className = 'snowflake';
    // zichtbare inhoud: unicode sneeuwvlok (je kunt hier ook an image gebruiken)
    flake.textContent = '❄';

    // willekeurige startpositie
    flake.style.left = (Math.random() * 100) + 'vw';

    // willekeurige grootte
    const size = 6 + Math.random() * 22; // px
    flake.style.fontSize = size + 'px';

    // variabele duur en delay
    const duration = 6 + Math.random() * 8; // seconden
    flake.style.setProperty('--dur', duration + 's');
    flake.style.animationDuration = duration + 's';
    flake.style.animationDelay = (Math.random() * 8) + 's';

    // licht verschillende opaciteit
    flake.style.opacity = 0.6 + Math.random() * 0.4;

    container.appendChild(flake);
  }
})();
